import styled from "@emotion/styled";
import { Button, Container, Grid } from "@mui/material";
import React from "react";

const Wrapper = styled.div`
  background-color: #000000;
  padding-top: 70px;
  padding-bottom: 70px;
  color: #ffffff;
`;
const Heading = styled.h1`
  font-size: 35px;
  font-weight: 700;
  max-width: 75%;
  @media (max-width: 1199px) {
    max-width: 80%;
    font-size: 35px;
  }
  @media (max-width: 599px) {
    max-width: 100%;
    font-size: 35px;
  } ;
`;
const Text = styled.div`
  padding-top: 30px;
  //   font-size: 50px;
  //   font-weight: 700;
  //   max-width: 60%;
`;
const FormDiv = styled.div`
  padding: 15px 0 7px 0px;
`;
const Input = styled.input`
  padding: 20px 0px 20px 20px;
  border-radius: 7px;
  max-width: 100%;
  width: 90%;
  outline: 0px dotted;
  outline: 0px auto -webkit-focus-ring-color;
  border: none;
`;
const Label = styled.label`
  font-size: 20px;
`;
const SubmitButton = styled.button`
  margin-top: 25px;
  border-radius: 7px;
  color: #ffffff;
  cursor: pointer;
  outline: 0px dotted;
  outline: 0px auto -webkit-focus-ring-color;
  border: none;
  background-color: #afbbb7;
  padding: 20px 0 20px 0;
  max-width: 100%;
  width: 93%;
  @media (max-width: 599px) {
    width: 98%;
  } ;
`;
const index = () => {
  return (
    <div>
      <Wrapper id="contact">
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Heading>Let's Discuss Your Next Project</Heading>
              <Text>
                Fill out the form, or call us <br />
                to set up a free in-home consultation.
                <br />
                <br />
                Postal Address: 438-D, Media Town, Lohi-Bher, 44000, Islamabad,
                Pakistan.
                <br />
                <br />
                Contact no: 0333-5702025, 0333-5532546, 0347-9046856
                <br />
                <br />
                Email: paramountvaultpk@gmail.com
              </Text>
            </Grid>
            <Grid item xs={12} md={6}>
              <Heading> Send Us Message</Heading>
              <form
              //   onSubmit={handleSubmit}
              >
                <div>
                  <FormDiv>
                    <Label htmlFor="username">Name:</Label>
                  </FormDiv>
                  <Input
                    // value={formValues.username}
                    // onChange={handleChange}
                    type="text"
                    name="username"
                    id="username"
                    placeholder="Enter name"
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {/* {formErrors.username} */}
                </div>
                <div>
                  <FormDiv>
                    <Label htmlFor="email">Email:</Label>
                  </FormDiv>

                  <Input
                    // value={formValues.email}
                    // onChange={handleChange}
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter email"
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {/* {formErrors.email} */}
                </div>
                <div>
                  <FormDiv>
                    <Label htmlFor="phone">Phone Number:</Label>
                  </FormDiv>
                  <Input
                    // value={formValues.phonenumber}
                    type="number"
                    name="phonenumber"
                    id="phonenumber"
                    placeholder="Phone Number"
                    // onChange={handleChange}
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {/* {formErrors.phonenumber} */}
                </div>

                <SubmitButton type="submit">Submit</SubmitButton>
              </form>
            </Grid>
          </Grid>
        </Container>
      </Wrapper>
    </div>
  );
};

export default index;
